import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { showModal, showSpinner } from '../../../actions'
import Manuals from './Manuals'

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ showModal, showSpinner }, dispatch)
}

export default connect(
  null,
  mapDispatchToProps
)(Manuals)
